import { render, staticRenderFns } from "./modalComentarios.vue?vue&type=template&id=31310489"
import script from "./modalComentarios.vue?vue&type=script&lang=js"
export * from "./modalComentarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports